<template>
    <div class="agri-platform-container">
        <div class="top-title">
            <h2>数字农业园区大数据分析平台</h2>
        </div>
        <!-- 主体内容区域 -->
        <el-row :gutter="16" class="main-content">
            <!-- 左侧：数字农业智能驾驶舱 -->
            <el-col :span="11">
                <img :src="dashboardImg" alt="数字农业智能驾驶舱" class="main-img">
            </el-col>

            <!-- 右侧：平台描述 -->
            <el-col :span="13">
                <div class="desc-card">
                    <p>我公司针对现代农业园区管理需求，创新研发数字农业园区大数据分析平台，为农业生产提供智能化决策支持。该平台深度融合多源数据采集与分析技术，全面整合温室环境参数、气象监测数据及设备运行状态等关键信息，构建农业生产的数字化管理体系。
                    </p>
                    <p>平台具备多温室数据智能比对功能，可对不同种植区域的环境指标进行横向分析，直观呈现各区域生长状况差异。通过实时监控界面，管理者能够随时掌握温室环境动态变化和设备运转情况，实现远程精准调控。系统自动追踪记录农事操作全过程，建立标准化生产档案，确保每个环节可查询、可追溯。
                    </p>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'AgriPlatformPage',
    data() {
        return {
            dashboardImg: require('@/assets/images/Mainsoftware/sznyyq.png')

        }
    }
}
</script>
